import { Button } from '@qodo/design-system';
import { spawn } from 'utils/translations';

interface DeleteAccountBlockersProps {
  hasActiveSub: boolean;
  blockedTeamName?: string;
  onCancelSubscription: () => void;
  onDeleteTeam: () => void;
}

export const DeleteAccountBlockers = ({
  hasActiveSub,
  blockedTeamName,
  onCancelSubscription,
  onDeleteTeam,
}: DeleteAccountBlockersProps) => {
  const spawnDialog = spawn('dialogs.user-settings');

  return (
    <div className="flex flex-col gap-2 border-l-2 border-amber-500/60 pl-3 py-1">
      <span className="text-xs font-semibold text-amber-400 leading-snug">
        {spawnDialog('delete-account.blocked-header')}
      </span>
      <ul className="flex flex-col gap-2">
        {hasActiveSub && (
          <li className="flex items-center justify-between gap-2">
            <span className="text-xs text-primary-foreground/90">
              {spawnDialog('delete-account.blocked-sub-item')}
            </span>
            <Button variant="danger" size="xs" onClick={onCancelSubscription}>
              {spawnDialog('delete-account.blocked-sub-cta')}
            </Button>
          </li>
        )}
        {blockedTeamName && (
          <li className="flex items-center justify-between gap-2">
            <span className="text-xs text-primary-foreground/90">
              {spawnDialog('delete-account.blocked-team-item', {
                teamName: blockedTeamName,
              })}
            </span>
            <Button variant="danger" size="xs" onClick={onDeleteTeam}>
              {spawnDialog('delete-account.blocked-team-cta')}
            </Button>
          </li>
        )}
      </ul>
    </div>
  );
};
